import { EditableProfileWrapper } from "./EditableProfileWrapper";

interface EditableProfileEmailProps {
    email: string;
    emailLabel?: string;
}

export const EditableProfileEmail = ({ email, emailLabel }: EditableProfileEmailProps) => {
    return (
        <EditableProfileWrapper
            title={emailLabel}
            headers={{
                hideEditing: true,
            }}
            data={[email]}
        ></EditableProfileWrapper>
    );
};

export default EditableProfileEmail;
